import React, { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

export default function LicencaBloqueadaOverlay({ mensagem, onVerificar }) {
  const [verificando, setVerificando] = useState(false);

  const verificar = async () => {
    if (verificando) return;
    setVerificando(true);
    try {
      await onVerificar();
    } catch {
      /* rede */
    } finally {
      setVerificando(false);
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 2000,
        bgcolor: 'rgba(0,0,0,0.54)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 480, textAlign: 'center' }}>
        <LockOutlinedIcon color="error" sx={{ fontSize: 52, mb: 2 }} />
        <Typography variant="h6" gutterBottom>
          Licença bloqueada
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {mensagem || 'Licença bloqueada. Entre em contato com o suporte.'}
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 3 }}>
          O sistema fica indisponível até a licença ser liberada. Após a liberação,
          use o botão abaixo ou aguarde a verificação automática.
        </Typography>
        <Button
          variant="contained"
          onClick={verificar}
          disabled={verificando}
          startIcon={verificando ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {verificando ? 'Verificando...' : 'Verificar novamente'}
        </Button>
      </Paper>
    </Box>
  );
}
